import DeviceRegList from "src/pages/DeviceRegistration/DeviceRegList";
import TraineeDeviceRegList from "src/pages/DeviceRegistration/TraineeDeviceRegList";


export const deviceRegistrationRoutes = [
  // trainee device registration
  { path: '/trainee/device-registration', component: TraineeDeviceRegList },
  { path: '/device-registration', component: DeviceRegList },
];
